<ng-container *transloco="let t">
    @if(layoutService.state().viewport !== 'desktop') {
    <button type="button" class="button-undecorated button-mobile" (click)="closeModal()"
        [attr.aria-label]="t('modals.premium_promo.ariaLabelClose')">
        <cwo-round-icon [iconName]="IconNameType.close" [size]="'medium'" aria-hidden="true" />
    </button>
    }
    <div class="plan-wrapper">
        <div class="plan-card">
            <span class="plan-card-art" aria-hidden="true"></span>
            <div class="plan-card-info">
                <h1 class="plan-card-name">{{t('modals.premium_promo.multiplan_title')}}</h1>
                <p id="premium-promo-subtitle" class="subtitle" [innerHTML]="savingsHeadline()"></p>
            </div>
            @if(layoutService.state().viewport === 'desktop') {
            <button type="button" class="button-undecorated" (click)="closeModal()"
                [attr.aria-label]="t('modals.premium_promo.ariaLabelClose')">
                <cwo-round-icon [iconName]="IconNameType.close" [size]="'medium'" aria-hidden="true" />
            </button>
            }
        </div>
    </div>

    <div class="plans" role="radiogroup">
        @for (vm of planViewModels(); track vm.name) {
        @let selected = isSelected(vm);
        @let planId = idBase + '-' + $index;

        <div class="plan" role="radio" tabindex="0" [class.plan-selected]="selected" [attr.aria-checked]="selected"
            [attr.aria-labelledby]="planId + '-name ' + planId + '-price'" [attr.aria-describedby]="planId + '-perks'"
            (click)="selectPlan(vm)" (keydown.enter)="selectPlan(vm)"
            (keydown.space)="selectPlan(vm); $event.preventDefault()">
            <header class="plan-header">
                <h2 class="plan-name" [id]="planId + '-name'">{{ vm.displayName }}</h2>
                <p class="plan-price" [id]="planId + '-price'">
                    <span class="plan-amount">{{ vm.price }}</span>
                    <span class="plan-period">/{{ t('modals.premium_promo.per_month') }}</span>
                </p>
            </header>

            <ul class="perks" [id]="planId + '-perks'">
                @for (perk of vm.perks; track perk.text) {
                <li class="perks-item" [class.perks-item-disabled]="perk.disabled">
                    <span class="perks-label">{{ perk.text }}</span>

                    @if (perk.factor) {
                    <span class="perks-factor">{{ perk.factor }}</span>
                    } @else if (!perk.disabled) {
                    <cwo-round-icon [iconName]="IconNameType.check" aria-hidden="true" [customSize]="'17px'"
                        [customIconSize]="'9px'" [customPadding]="'1px'" [customBackgroundColor]="'var(--primary)'"
                        [customColor]="'var(--white)'" />
                    <span class="sr-only">{{ t('modals.premium_promo.perk_included_aria') }}</span>
                    } @else {
                    <span class="sr-only">{{ t('modals.premium_promo.perk_not_included_aria') }}</span>
                    }
                </li>
                }
            </ul>
        </div>
        }
    </div>
</ng-container>